import { Field, useFormikContext } from "formik";
import React, { useEffect, useState } from "react";
import TableBody from "@mui/material/TableBody";
import { calculateSum } from "../../CommonFuntion/TotalQuantity";
import {
  requestOptions,
  VIPSDataServiceURL,
} from "../../Constants/GlobalConstant";
import Button from "@mui/material/Button";
import { useNavigate, useLocation, createSearchParams } from "react-router-dom";
import { getSessionObjectId } from "../../CommonFuntion/indexHelper";
import { sessionCache } from "../../CommonFuntion/sessionCache";
import Tooltip from "@mui/material/Tooltip";
import WarningIcon from "@mui/icons-material/Warning";
import { pink } from "@mui/material/colors";

export function CatalogueTableBodyFormik(props) {
  const formikProps = useFormikContext();
  let { setFieldValue, values, errors } = formikProps;
  const { value, element, catalogueDetailDataKey } = props.catTabData || {};
  let {
    setPurchasedQty,
    totalSum,
    setTotalSum,
    name,
    catalogueChildOptn,
    user_id,
    store_grp,
  } = props;
  const [tableData, setTableData] = useState([]);
  const [inputValue, setInputValue] = useState("");
  // Detect if catalogue table has any qty fields (catalogueSchemaType === 16)
  const hasQtyFields =
    Array.isArray(props.schemaPageFields) &&
    props.schemaPageFields.some((schema) => schema.catalogueSchemaType === 16);

  const location = useLocation();
  const searchParams = createSearchParams(location.search);
  useEffect(() => {
    // Only compute totals if qty fields exist
    if (hasQtyFields) {
      setTotalSum(calculateSum(props, tableData));
    }
    // Update per-table flags for index.js validation
    window.__tableTotals = window.__tableTotals || {};
    window.__tableTotals[props.name] = {
      hasQty: hasQtyFields,
      totalZero: hasQtyFields ? Number(totalSum) === 0 : false,
    };
  }, [tableData, hasQtyFields, totalSum, props.name]);

  // Maps raw catalogue rows onto the schema fields, caches the unique
  // LABEL_REF/LABEL_REF1 values and updates table, Formik, qty and totals.
  const applyCatalogueRows = (rows) => {
    const tableResults = rows.map(() => ({}));
    const purchasedQty = [];
    const uniqueLabelRef1Values = new Set();
    props.schemaPageFields?.forEach((schema) => {
      rows.forEach((obj, index) => {
        const res = obj.find((x) => x.ID === schema.catFieldId);

        if (res) {
          if (
            res.Description === "LABEL_REF" ||
            res.Description === "LABEL_REF1"
          ) {
            uniqueLabelRef1Values.add(res.Value);
          }
          tableResults[index][schema.fieldName] = res.Value;
          if (schema.catalogueSchemaType === 16) {
            purchasedQty.push(res.Value);
          }
        } else tableResults[index][schema.fieldName] = "";
      });
    });
    const uniqueLabelRef1Array = Array.from(uniqueLabelRef1Values);
    if (uniqueLabelRef1Array.length > 0) {
      sessionCache.set(
        user_id + getSessionObjectId(searchParams) + "uniqueLabelRef1",
        uniqueLabelRef1Array
      );
    }
    setTableData(tableResults);
    setFieldValue(props.name, tableResults);
    setPurchasedQty(purchasedQty);
    // Recompute totals if qty fields exist
    if (hasQtyFields) {
      setTotalSum(calculateSum(props, tableResults));
    }
  };

  useEffect(() => {
    if (element?.catId && catalogueDetailDataKey) {
      const getCatalogueHeaderDataApiUrl =
        `${VIPSDataServiceURL}/Catalogue/GetCatalogueDetailData` +
        `?catId=${element?.catId}&pageID=${props.schemaPageFields[0]?.pageId}${catalogueDetailDataKey}` +
        `&storeGrp=${store_grp}` +
        `&userId=${user_id}`;

      fetch(getCatalogueHeaderDataApiUrl, requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.catData.length > 0) {
            applyCatalogueRows(data.catData);
          } else {
            setTableData([]);
            setFieldValue([]);
          }
        });
    }
    if (catalogueChildOptn) {
      applyCatalogueRows(catalogueChildOptn);
      setTableData(props.tableData);
    } else {
      setTableData([]);
      setFieldValue([]);
    }
  }, [catalogueChildOptn, props.catTabData, hasQtyFields]);

  useEffect(() => {
    if (values?.[props.name]) setTableData(values[props.name]);
  }, [values?.[props.name]]);

  const getFormElementtr = (element, index) => {
    //const name = element.fieldName;

    return (
      <>
        {props.schemaPageFields.map((schema, schIndex) => {
          if (schema.catalogueSchemaType === 16) {
            const error = errors?.[props.name]?.find((x) => x?.index === index);
            const errorBorder = error?.[schema.fieldName] ? "error-border" : "";
            const handleApplyClick = () => {
              let i = 0;
              tableData.forEach((x) => {
                //const InputQuantity = tableData[`${i}`];
                const InputQuantity = tableData[`${i}`][schema.fieldName];
                const wastage = parseInt(inputValue, 10);
                if (InputQuantity !== "" && !isNaN(wastage)) {
                  var wastagePercent = 0;
                  var wastageQunatity = 0;
                  wastagePercent = wastage / 100;
                  wastageQunatity = parseInt(InputQuantity) * wastagePercent;
                  tableData[`${i}`][schema.fieldName] = parseInt(
                    parseInt(InputQuantity) + Math.ceil(wastageQunatity)
                  ).toString();
                }
                i = i + 1;
              });

              setTotalSum(calculateSum(props, tableData));
            };
            return (
              <>
                <td key={schIndex}>
                  <div className="wrapper">
                    <div>
                      <Field
                        className={`tableInput ${errorBorder}`}
                        key={schIndex}
                        type="text"
                        name={`${props.name}[${index}].${schema.fieldName}`}
                        // bind value so "0" stays visible
                        value={element[schema.fieldName] ?? ""}
                        onChange={(e) => {
                          const val = e.target.value; // keep as string, allow "0"
                          // update Formik state
                          setFieldValue(`${props.name}[${index}].${schema.fieldName}`, val);
                          // keep local tableData in sync to recompute totals immediately
                          const next = [...tableData];
                          next[index] = { ...next[index], [schema.fieldName]: val };
                          setTableData(next);
                          if (hasQtyFields) {
                            setTotalSum(calculateSum(props, next));
                          }
                        }}
                        inputMode="numeric"
                        pattern="[0-9]*"
                      />
                      {error?.[schema.fieldName] && (
                        <span className="icon">
                          <Tooltip title={error?.[schema.fieldName]}>
                            <WarningIcon sx={{ color: pink[500] }} />
                          </Tooltip>
                        </span>
                      )}
                    </div>
                  </div>
                </td>

                <td key={schIndex + 11}>
                  {index === 0 && (
                    <>
                      <input
                        type="text"
                        className="wastage-input"
                        onChange={(e) => setInputValue(e.target.value)}
                      />
                      %
                      <Button
                        className="clearbtn"
                        variant="contained"
                        onClick={handleApplyClick}
                        component="label"
                        sx={{ textTransform: "none" }}
         size="small"
                      >
                        Apply
                      </Button>
                    </>
                  )}
                </td>
              </>
            );
          } else {
            if(schema.visible === false) {
              return null;
            }
            return <td key={schIndex}>{element[schema.fieldName]}</td>;
          }
        })}
      </>
    );
  };
  return (
    <>
      <TableBody>
        {tableData.map((element, index) => {
          return <tr key={index}>{getFormElementtr(element, index)}</tr>;
        })}
        {tableData.length > 0 && (
          <tr>
            {props.schemaPageFields.map((schema, schIndex) => {
              if (schema.catalogueSchemaType === 16) {
                return (
                  <>
                    <td key={schIndex}>
                      <Field type="text" value={totalSum} disabled />
                    </td>
                    <td></td>
                  </>
                );
              } else {
                 const isVisible = schema.visible ;

              return isVisible ? <td key={schIndex}></td> : null;
              }
            })}
          </tr>
        )}
      </TableBody>
    </>
  );
}

export default CatalogueTableBodyFormik;
